// components/SmartNotFound.jsx
import { Link2OffIcon } from 'lucide-react';
import React, { useMemo, useState,useEffect } from 'react';
import { useNavigate, useLocation,Link } from 'react-router-dom';

const SmartNotFound = ({ availableRoutes = [] }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  const location = useLocation();
useEffect(()=>{
    setIsVisible(true);

})
  
  return ( 
    <div className="min-h-screen bg-gradient-to-br from-black-900/90 via-white to-green-900/90 text-white flex items-center justify-center px-4">
      
      <div className="relative z-10 text-center max-w-2xl mx-auto">
      <div className="absolute inset-0 opacity-5">
          
        </div>
        <h1 className="text-8xl font-black bg-gradient-to-r from-green-400 to-black-400 bg-clip-text text-transparent mb-8">
          404
        </h1>

        <h2 className="text-3xl font-bold mb-4">Page Not Found</h2>


        <Link
          to='/'
          className="mt-8 px-8 py-4 bg-gradient-to-r from-green-600 to-indigo-600 hover:from-green-700 hover:to-indigo-700 rounded-full font-semibold transition-all duration-300 hover:scale-105"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default SmartNotFound;
